import React from "react";
import AgentV2 from './agentv2';

const AgentsV2 = (props) => {
    let listing = props.listing;

    if (listing.agents) {

        var agents = listing.agents.slice(0,4).map(function (item, index) {
            let layoutIsMin = true;

            if (listing.agents.length >= 3) {
                layoutIsMin = true;
            } else if (listing.agents.length === 2 && item.hasImage === true && listing.agents[1].hasImage === true) {
                layoutIsMin = false;
            } else if (listing.agents.length === 1 && item.hasImage && item.imageSrc != null) {
                layoutIsMin = false;
            }

            return (<AgentV2 agent={item} print={listing.print} key={index} layoutIsMin={layoutIsMin} />);
        });

        return (
            <div className="print-agents-container">
                {agents}
            </div>
        );
    } else {
        return null;
    }
}

export default AgentsV2;



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/agentsv2.js